import { EmployeeWorkLetterType } from 'src/api';
import { DashboardPalette } from 'src/constants/dashboard';

export const WORK_LETTER_TYPES = [
  EmployeeWorkLetterType.Employment,
  EmployeeWorkLetterType.EmploymentWithIncomeInfo,
  EmployeeWorkLetterType.Immigration,
] as const;

export const WORK_LETTER_TYPE_TO_TITLE_MAP = {
  [EmployeeWorkLetterType.Employment]: 'Employment',
  [EmployeeWorkLetterType.EmploymentWithIncomeInfo]: 'Employment with Income',
  [EmployeeWorkLetterType.Immigration]: 'Immigration',
} as const satisfies Record<EmployeeWorkLetterType, string>;

export const WORK_LETTER_TYPE_TO_COLOR_MAP = {
  [EmployeeWorkLetterType.Employment]: DashboardPalette.grey,
  [EmployeeWorkLetterType.EmploymentWithIncomeInfo]: DashboardPalette.green400,
  [EmployeeWorkLetterType.Immigration]: DashboardPalette.blue200,
} as const satisfies Record<EmployeeWorkLetterType, DashboardPalette>;
